import { Form, Formik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

import Button from "@/components/Button/Button"
import { MODALS } from "@/constants/modals"
import { useAddProjectMutation } from "@/queries/mutations/projectMutations"
import { useStore } from "@/zustand/store"

import ProjectsInputes from "./ProjectsInputes"

export default function ProjectAdd() {
  const { t } = useTranslation()
  const editModalState = useStore((state) => state.editModalState)

  const addProjectMutation = useAddProjectMutation()

  const projectSchema = Yup.object().shape({
    title: Yup.string().required(t("newProjectModal.errors.title")),
    link: Yup.string()
      .url(t("newProjectModal.errors.link"))
      .required(t("newProjectModal.errors.link")),
    description: Yup.string().nullable(),
    video_link: Yup.string()
      .url(t("newProjectModal.errors.videoLink"))
      .nullable(),
  })

  return (
    <>
      <Formik
        initialValues={{
          title: "",
          description: "",
          link: "",
          video_link: "",
        }}
        validationSchema={projectSchema}
        enableReinitialize
        onSubmit={(values) => {
          addProjectMutation.mutate(values, {
            onSuccess: () => editModalState(MODALS.projects.add, undefined),
          })
        }}
      >
        {() => {
          return (
            <Form>
              <ProjectsInputes />

              <div className="d-flex justify-content-end gap-3 mt-3">
                <Button
                  type="button"
                  onClick={() => editModalState(MODALS.projects.add, undefined)}
                  variant={"secondary_border"}
                >
                  {t("buttons.cancel")}
                </Button>
                <Button isLoading={addProjectMutation.isPending} type="submit">
                  {t("buttons.save")}
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
